export default __webpack_public_path__ + "static/media/POKI2@3x.c0b978d8.png";